import React from 'react';
import { Card, CardBody, Table, Row, Col } from 'reactstrap';
import AddressHelper from '@components/Elements/AddressHelper/AddressHelper';

export default props => {
  return (
    <Card className={'h-100 card-form'}>
      <CardBody>
        <div className={'font-md color-blue'}>
          <span className={'text-capitalize'}>Unit Information</span>
          <button onClick={props.toggle}>Edit</button>
        </div>
        <div className={'pt-2 content'}>
          <Row>
            <Col>
              <Table size={'sm'} borderless>
                <tbody>
                  <tr>
                    <th className={'w-25'}>Address</th>
                    <td>
                      {props.entity.address_no} {props.entity.street}
                      {props.entity.unit_no !== null &&
                        props.entity.unit_no.length > 0 &&
                        `, #${props.entity.unit_no}`}
                      <br />
                      <AddressHelper
                        {...props.entity}
                        address_line_1={null}
                        address_line_2={null}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col>
              <Table size={'sm'} borderless>
                <tbody>
                  <tr>
                    <th className={'w-25'}>Phase</th>
                    <td>{props.entity.phase_no}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
      </CardBody>
    </Card>
  );
};
